import { Table } from "reactstrap";

const ReportTable = ({ header, obj, theme }) => {
  const hasGroupedConnectionPoints = () => {
    return obj.find((o) => o.groupedConnectionPoints.length > 0) ? true : false;
  };

  const showPremisesId =
    header === "Nodal Connections" &&
    obj.some((groupedConnection) =>
      groupedConnection.groupedConnectionPoints?.some((gcp) => gcp.premisesId),
    );

  const convertType = (type) => {
    return type === "AnnualConsumption"
      ? "AC"
      : type === "MaximumDemandDiversified"
        ? "MDD"
        : type === "MaximumDemand"
          ? "MDF"
          : "";
  };

  const L1Count = (groupedConnectionPoint) =>
    (groupedConnectionPoint.phase1Consumers ?? 0) +
    (groupedConnectionPoint.phase1AutoConsumers ?? 0);
  const L2Count = (groupedConnectionPoint) =>
    (groupedConnectionPoint.phase2Consumers ?? 0) +
    (groupedConnectionPoint.phase2AutoConsumers ?? 0);
  const L3Count = (groupedConnectionPoint) =>
    (groupedConnectionPoint.phase3Consumers ?? 0) +
    (groupedConnectionPoint.phase3AutoConsumers ?? 0);

  return (
    <>
      {hasGroupedConnectionPoints() && (
        <>
          <h5 style={{ paddingLeft: ".3rem" }}>{header}</h5>
          <Table
            style={{ marginBottom: "3rem" }}
            className={`table-sm table-custom table-custom-${theme}`}
          >
            <thead>
              <tr className="mb-4">
                <th>Node Number</th>
                {showPremisesId && <th>Premises ID</th>}
                <th>No Consumers</th>
                <th>No Phases</th>
                <th>L1 Count</th>
                <th>L2 Count</th>
                <th>L3 Count</th>
                <th>Profile</th>
                <th>Type</th>
                <th>Day (kW/kWh)</th>
                <th>Night (kW/kWh)</th>
                <th>Child Profile</th>
                <th>Child Type</th>
                <th>Child Day (kW/kWh)</th>
                <th>Child Night (kW/kWh)</th>
              </tr>
            </thead>
            <tbody>
              {obj.map((groupedConnection) =>
                groupedConnection.groupedConnectionPoints.map((groupedConnectionPoint) =>
                  groupedConnectionPoint.subGroupConnectionPoints.length > 0 ? (
                    groupedConnectionPoint.subGroupConnectionPoints.map(
                      (subGroupConnectionPoint, i, arr) => (
                        <tr key={`tr1-${groupedConnectionPoint.id}`}>
                          {i === 0 && (
                            <>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {header === "Distributed Connections"
                                  ? `${groupedConnection.nearNodeNumber} - ${groupedConnection.farNodeNumber}`
                                  : groupedConnectionPoint.nodeNumber}
                              </td>
                              {showPremisesId && (
                                <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                  {groupedConnectionPoint.premisesId}
                                </td>
                              )}
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {groupedConnectionPoint.count}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {groupedConnectionPoint.numberOfPhases}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {L1Count(groupedConnectionPoint)}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {L2Count(groupedConnectionPoint)}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {L3Count(groupedConnectionPoint)}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {groupedConnectionPoint.consumerType}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {convertType(groupedConnectionPoint.consumptionType)}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {groupedConnectionPoint.consumptionValue1}
                              </td>
                              <td rowSpan={arr.length} style={{ verticalAlign: "middle" }}>
                                {groupedConnectionPoint.consumptionValue2}
                              </td>
                            </>
                          )}
                          <td>{subGroupConnectionPoint.consumerType}</td>
                          <td>{convertType(subGroupConnectionPoint.consumptionType)}</td>
                          <td>{subGroupConnectionPoint.consumptionValue1}</td>
                          <td>{subGroupConnectionPoint.consumptionValue2}</td>
                        </tr>
                      ),
                    )
                  ) : (
                    <tr key={`tr2-${groupedConnectionPoint.id}`}>
                      <td>{groupedConnectionPoint.nodeNumber}</td>
                      {showPremisesId && <td>{groupedConnectionPoint.premisesId}</td>}
                      <td>{groupedConnectionPoint.count}</td>
                      <td>{groupedConnectionPoint.numberOfPhases}</td>
                      <td>{L1Count(groupedConnectionPoint)}</td>
                      <td>{L2Count(groupedConnectionPoint)}</td>
                      <td>{L3Count(groupedConnectionPoint)}</td>
                      <td>{groupedConnectionPoint.consumerType}</td>
                      <td>{convertType(groupedConnectionPoint.consumptionType)}</td>
                      <td>{groupedConnectionPoint.consumptionValue1}</td>
                      <td>{groupedConnectionPoint.consumptionValue2}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ),
                ),
              )}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};

export default ReportTable;
